import { NativeWindStyleSheet } from 'nativewind'

import { default as _colors } from './colors'
import colorVars from './theme-colors'

export let colors = resolveColors(_colors)

function reconstructColors() {
  colors = resolveColors(_colors)
}

export function resolveColors(colors) {
  return Object.keys(colors).reduce((acc, key) => {
    if (typeof colors[key] === 'object') {
      acc[key] = resolveColors(colors[key])
    }
    if (typeof colors[key] === 'string' && colors[key].startsWith('var(--')) {
      const color = colors[key].replace('var(', '').replace(')', '')
      const value = colorVars[color] ?? colors[key]
      acc[key] = value
    }
    return acc
  }, {}) as typeof colors
}

export function setNativewindColors(obj: { [key: string]: string }) {
  colors = {
    ...colors,
    ...obj,
  }
  Object.keys(obj).forEach((key) => {
    NativeWindStyleSheet.setVariables({
      [key]: obj[key],
    })
  })
  reconstructColors()
}

export function initColors() {
  reconstructColors()
}
